import React from 'react';
import dettol from "../images/dettole.png"
import { Link } from 'react-router-dom';
import helpicon from "../images/Vector (3).png"
import { useLocation } from 'react-router-dom';


const Ordercancel = () => {

  const location = useLocation();
    const { reason } = location.state || {}; 
  return (
    <div className="bg-white py-12 px-4 lg:px-20 lg:mt-[1px] mt-20">
      <div className="container mx-auto">

        {/* Shipment Details and Summary Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

          {/* Shipment Details */}
          <div className="col-span-2">
          <h2 className="text-lg font-bold mb-2">Shipment Details</h2>

          <div className="border border-gray-300 rounded-[30px] lg:p-8 p-4 mb-6">
                            <div className="flex justify-between">
                                <div>
                                    <p className="text-sm text-gray-600">Order ID</p>
                                    <p className="text-lg font-semibold">1234567890</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-600">Placed On</p>
                                    <p className="text-lg font-semibold">23 July 2024</p>
                                </div>
                            </div>
                        </div>

            {/* Delivery Details */}
            <div className="mb-6">
  <h2 className="text-lg font-bold mb-2">Delivery Details</h2>
  <p className="text-red-600 font-semibold">Order Cancelled</p>
  <p>Cancellation Reason: {reason}</p>

  {/* Progress Bar */}
  <div className="flex flex-col sm:flex-row items-center mb-4">
    <div className="text-center mb-4 sm:mb-0">
      <p className="text-sm">12:02PM 23/07/2024</p>
      <div className="w-6 h-6 bg-green-900 rounded-full mx-auto"></div>
      <p className="text-xs mt-1">Order Placed</p>
    </div>

    <div className="sm:flex-1 border-l sm:border-t border-gray-300 mx-2 sm:mx-0 sm:my-2 h-8 sm:h-auto"></div>

    {/* X Mark for Canceled Order */}
    <div className="text-center mb-4 sm:mb-0">
      <p className="text-sm">12:02PM 23/07/2024</p>
      <div className="w-6 h-6 bg-red-600 text-white rounded-full mx-auto flex items-center justify-center">
        {/* X Mark SVG */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
      <p className="text-xs mt-1">Packing</p>
    </div>

    <div className="sm:flex-1 border-l sm:border-t border-gray-300 mx-2 sm:mx-0 sm:my-2 h-8 sm:h-auto"></div>

    <div className="text-center mb-4 sm:mb-0">
      <div className="w-6 h-6 bg-gray-300 rounded-full mx-auto"></div>
      <p className="text-xs mt-1">On the way</p>
    </div>

    <div className="sm:flex-1 border-l sm:border-t border-gray-300 mx-2 sm:mx-0 sm:my-2 h-8 sm:h-auto"></div>

    <div className="text-center">
      <div className="w-6 h-6 bg-gray-300 rounded-full mx-auto"></div>
      <p className="text-xs mt-1">Delivered</p>
    </div>
  </div>
</div>



            {/* Items Section */}
            <div>
              <h2 className="text-lg font-bold mb-4">Items</h2>
              
              {/* Item 1 */}
              <Link to="/featureproduct"> 
              <div className="border p-4 rounded-lg mb-4">
                <div className="flex">
                  <img src={dettol} alt="Dettol" className="w-16 h-16 object-cover mr-4" />
                  <div className="flex-1">
                    <h3 className="font-semibold">Dettol Antiseptic Disinfectant Liquid, 60ml</h3>
                    <p className="text-gray-500">By DETTOL</p>
                    <p className="text-gray-500 text-sm">60ML Liquid in Bottle</p>
                    <p className="text-green-600 font-semibold">₹150 <span className="text-gray-500 line-through ml-2">30% Off</span></p>
                  </div>
                </div>
              </div>
              </Link>

              {/* Item 2 (Repeat) */}
              <Link to="/featureproduct"> 
              <div className="border p-4 rounded-lg mb-4">
                <div className="flex">
                  <img src={dettol} alt="Dettol" className="w-16 h-16 object-cover mr-4" />
                  <div className="flex-1">
                    <h3 className="font-semibold">Dettol Antiseptic Disinfectant Liquid, 60ml</h3>
                    <p className="text-gray-500">By DETTOL</p>
                    <p className="text-gray-500 text-sm">60ML Liquid in Bottle</p>
                    <p className="text-green-600 font-semibold">₹150 <span className="text-gray-500 line-through ml-2">30% Off</span></p>
                  </div>
                </div>
              </div>
</Link>
            </div>
          </div>

          {/* Shipment Summary */}

          <div className="col-span-1">
          <h2 className="text-lg font-bold mb-2 text-right">100% Secure payments</h2>

            <div className="border rounded-lg p-6">
              <h2 className="text-lg font-bold mb-4">Shipment Summary</h2>
              <div className="flex justify-between mb-2">
                <span className="text-gray-600">MRP</span>
                <span className="font-semibold">₹252.00</span>
              </div>
              <div className="flex justify-between mb-2 text-green-600">
                <span>Discount</span>
                <span>₹50.00</span>
              </div>

              {/* Discount Breakup */}
              {/* <div className="bg-gray-100 p-4 rounded-lg mb-4">
                <p className="text-gray-600">Discount Breakup</p>
                <div className="flex justify-between mt-2">
                  <span className="text-sm text-gray-500">MRP Discount</span>
                  <span className="text-green-600">- ₹20.00</span>
                </div>
                <div className="flex justify-between mt-2">
                  <span className="text-sm text-gray-500">MRP Discount</span>
                  <span className="text-green-600">- ₹20.00</span>
                </div>
              </div> */}

              <div className="flex justify-between mb-2">
                <span className="text-gray-600">Discounted Price</span>
                <span className="font-semibold">₹102.00</span>
              </div>
              <div className="flex justify-between mb-2">
                <span className="text-gray-600">Delivery Fees</span>
                <span className="font-semibold">₹50.00</span>
              </div>

              <div className="flex justify-between border-t pt-4">
                <span className="font-semibold">Amount to be Paid</span>
                <span className="font-semibold">₹152.00</span>
              </div>
            </div>

            {/* Need Help Section */}
            <div className="flex items-center mt-6">
              <div className="text-red-600">
              <img className='lg:w-[35px] lg:h-[30px] w-[25px] h-[25px]' src={helpicon}></img>

              </div>
              <span className="ml-2 font-semibold">Need help?</span>
            </div>

            <Link to="/faq"> <button className="w-full bg-gray-100 text-black font-semibold py-2 rounded-lg mt-2 hover:bg-gray-200">FAQs & More</button></Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Ordercancel;
